// src/pages/expense/env/disinfection/ExpenseEnvDisinfectionDraftPreviewWindow.jsx
// ✅ 전 사업 확산 [2] — 환경/소독 통합 작성 페이지의 PDF 미리보기 전용 창(팝업).
// 실제 로직은 pages/expense/_shared/ExpenseDraftPreviewWindow.jsx(공통 컴포넌트)에
// 있고, 이 파일은 환경/소독 전용 config를 넘기는 얇은 래퍼일 뿐이다. 라우트
// element로 직접 쓰이므로(부모가 props를 못 내려줌) 래퍼가 필요하다.
import React from "react";
import ExpenseDraftPreviewWindow from "../../_shared/ExpenseDraftPreviewWindow";
import envDisinfectionConfig from "./envDisinfectionConfig";

export default function ExpenseEnvDisinfectionDraftPreviewWindow() {
  return <ExpenseDraftPreviewWindow config={envDisinfectionConfig} />;
}
